import { render, staticRenderFns } from "./goodLicenceTask.vue?vue&type=template&id=0fc0765a&scoped=true"
import script from "./goodLicenceTask.vue?vue&type=script&lang=js"
export * from "./goodLicenceTask.vue?vue&type=script&lang=js"
import style0 from "./goodLicenceTask.vue?vue&type=style&index=0&id=0fc0765a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc0765a",
  null
  
)

export default component.exports